'use client';

import Banner1 from '../assets/images/Banner-1.webp';
import Banner2 from '../assets/images/Banner-2.webp';
import Banner3 from '../assets/images/Banner-3.webp';
import Banner4 from '../assets/images/Banner-4.webp';
import Banner5 from '../assets/images/Banner-5.webp';
import Carousel from '../components/ui/Carousel';

export default function GamePromotion() {
  const images = [Banner1, Banner2, Banner3, Banner4, Banner5];

  return (
    <>
      {/* Pass the images array to the CustomCarousel component */}
      <div className='my-3.5 max-xs:my-2 px-5'>
        <Carousel images={images} />
      </div>
    </>
  );
}
